import React from 'react';
import { Tooltip } from 'react-tooltip';

import { ReactComponent as DeleteIcon } from '@assets/svg/manage-locations/ic-delete.svg';
import { ReactComponent as EditIcon } from '@assets/svg/manage-locations/ic-edit.svg';
import { ReactComponent as MoveIcon } from '@assets/svg/manage-locations/ic-move.svg';

import { MODAL_NAMES } from '@constants/modalRenderers';

import useTranslation from '@hooks/useTranslation';

import { useModalActions } from '@store/useModalStore';

import style from './style.module.scss';

interface IProps {
  id: string;
}

const ContextMenu: React.FC<IProps> = ({ id }) => {
  const { t } = useTranslation();

  const { setActiveModal } = useModalActions();

  return (
    <Tooltip
      id={id}
      place="left"
      openOnClick
      className={style.contextMenuPopover}
      clickable
      disableStyleInjection
      render={({ content }) => {
        if (!content) {
          return null;
        }
        const row = JSON.parse(content);
        return (
          <>
            <div
              className={style.contextMenuPopoverItem}
              onClick={() =>
                setActiveModal({
                  name: MODAL_NAMES.editLocationModal,
                  options: { locationId: row.id, locationName: row.name, parentId: row.parentId },
                })
              }
            >
              <EditIcon className={style.menuIcon} />
              {t('Edit')}
            </div>
            <div
              className={style.contextMenuPopoverItem}
              onClick={() =>
                setActiveModal({
                  name: MODAL_NAMES.locationMoveModal,
                  options: { locationId: row.id, locationName: row.name },
                })
              }
            >
              <MoveIcon className={style.moveIcon} />
              {t('Move')}
            </div>
            <div
              className={style.contextMenuPopoverItem}
              onClick={() =>
                setActiveModal({
                  name: MODAL_NAMES.locationDeleteModal,
                  options: { locationId: row.id, locationName: row.name },
                })
              }
            >
              <DeleteIcon className={style.menuIcon} />
              {t('Delete')}
            </div>
          </>
        );
      }}
    />
  );
};

export default ContextMenu;
